import PATH from '../paths';

const name = 'Business Owners And Wealth';
const key = 'businessowners';
const imgUrl = `${ PATH.CDN }/whitelabels/${ key }`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/logo.svg`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  logoSidebar: `${ imgUrl }/logo-sidebar.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/background.jpg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-businessowners-blue-light:   #00a8e8;
    --color-businessowners-blue-medium:  #007ea7;
    --color-businessowners-blue-dark:    #003459;
    --color-businessowners-black:        #000000;
    --color-businessowners-doveblue:     #818a91;

    --color-primary:                  var(--color-businessowners-blue-medium);
    --color-secondary:                var(--color-businessowners-black);
    --color-accent:                   var(--color-white);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-businessowners-blue-medium);
    --color-link-hover:               var(--color-darker);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              transparent;
    --anonymous-copy-bg:              var(--color-businessowners-blue-dark);
    --anonymous-heading-color:        var(--color-white);
    --anonymous-subheading-color:     var(--color-white);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          70px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-businessowners-blue-dark);
    --sidebar-logo-bg-color: #022b42
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color-businessowners-doveblue);

    --sidebar-button-color: var(--color-accent);
    --sidebar-button-color-active: var(--color-white);
    --sidebar-button-color-hover: var(--color-businessowners-black);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-businessowners-blue-medium);
    --sidebar-button-bg-color-hover: var(--color-accent);
    --sidebar-button-border-color: var(--color-accent);
    --sidebar-button-border-color-active: var(--color-businessowners-blue-medium);
    --sidebar-button-border-color-hover: var(--color-accent);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-businessowners-blue-medium);
    --btn-primary--border:            var(--color-businessowners-blue-medium);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-businessowners-black);
    --btn-primary--borderH:           var(--color-businessowners-black);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-businessowners-blue-medium);
    --btn-secondary--color:           var(--color-businessowners-black);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-businessowners-black);
    --btn-secondary--colorH:          var(--color-businessowners-black);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};